// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"wp_a bhv_b"};